var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgT2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_152_690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8184 0H1.99779C1.14534 0 0.718485 1.03065 1.32121 1.63338L30.3678 30.68C30.9706 31.2828 32.0012 30.8559 32.0012 30.0035V1.18281C32.0012 0.529569 31.4717 0 30.8184 0V0ZM25.6547 18.154C25.6547 18.4895 25.2492 18.6575 25.0119 18.4203L13.581 6.98931C13.3437 6.75207 13.5118 6.34648 13.8472 6.34648H25.1892C25.4463 6.34648 25.6547 6.55492 25.6547 6.81199V18.154Z",
    fill: "url(#paint0_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.813 4.02637H6.0593C5.70097 4.02637 5.52145 4.45962 5.77488 4.71305L31.7296 30.6678C31.8918 30.5023 31.9957 30.2745 31.9957 30.0029V5.20911C31.9957 4.55587 31.4662 4.02637 30.813 4.02637V4.02637ZM25.6498 18.154C25.6498 18.4892 25.2441 18.6575 25.0068 18.4201L13.5757 6.98907C13.3384 6.7517 13.5066 6.34605 13.8418 6.34605H25.184C25.4411 6.34605 25.6498 6.55468 25.6498 6.81187V18.154Z",
    fill: "url(#paint1_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6551 0.346102C31.441 0.132016 31.1455 0 30.8185 0H1.99836C1.14534 0 0.718485 1.03015 1.32115 1.63282L2.83977 3.15137H28.8498L31.6551 0.346102Z",
    fill: "url(#paint2_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8438 29.162L30.3623 30.6805C30.9649 31.2832 31.9951 30.8564 31.9951 30.0033V1.18326C31.9951 0.856295 31.8631 0.560766 31.649 0.34668L28.8438 3.15195V29.162Z",
    fill: "url(#paint3_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16437 0.876132V2.2766C4.16437 2.46653 4.0104 2.62045 3.82047 2.62045C3.63054 2.62045 3.47656 2.46647 3.47656 2.2766V0.876132C3.47656 0.686203 3.63054 0.532227 3.82047 0.532227C4.0104 0.532227 4.16437 0.686203 4.16437 0.876132Z",
    fill: "url(#paint4_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.09406 0.876132V1.59212C6.09406 1.78205 5.94008 1.93602 5.75015 1.93602C5.56023 1.93602 5.40625 1.78205 5.40625 1.59212V0.876132C5.40625 0.686203 5.56023 0.532227 5.75015 0.532227C5.94008 0.532227 6.09406 0.686203 6.09406 0.876132V0.876132Z",
    fill: "url(#paint5_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01593 0.876132V1.59212C8.01593 1.78205 7.86196 1.93602 7.67203 1.93602C7.4821 1.93602 7.32812 1.78205 7.32812 1.59212V0.876132C7.32812 0.686203 7.4821 0.532227 7.67203 0.532227C7.86202 0.532227 8.01593 0.686203 8.01593 0.876132V0.876132Z",
    fill: "url(#paint6_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94556 0.876132V2.2766C9.94556 2.46653 9.79159 2.62045 9.60172 2.62045C9.41179 2.62045 9.25781 2.46647 9.25781 2.2766V0.876132C9.25781 0.686203 9.41179 0.532227 9.60172 0.532227C9.79159 0.532227 9.94556 0.686203 9.94556 0.876132Z",
    fill: "url(#paint7_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8753 0.876132V1.59212C11.8753 1.78205 11.7213 1.93602 11.5314 1.93602C11.3415 1.93602 11.1875 1.78205 11.1875 1.59212V0.876132C11.1875 0.686203 11.3415 0.532227 11.5314 0.532227C11.7213 0.532227 11.8753 0.686203 11.8753 0.876132V0.876132Z",
    fill: "url(#paint8_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7972 0.876132V1.59212C13.7972 1.78205 13.6432 1.93602 13.4533 1.93602C13.2634 1.93602 13.1094 1.78205 13.1094 1.59212V0.876132C13.1094 0.686203 13.2634 0.532227 13.4533 0.532227C13.6432 0.532227 13.7972 0.686203 13.7972 0.876132V0.876132Z",
    fill: "url(#paint9_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7268 0.876132V2.2766C15.7268 2.46653 15.5728 2.62045 15.3829 2.62045C15.193 2.62045 15.0391 2.46647 15.0391 2.2766V0.876132C15.0391 0.686203 15.193 0.532227 15.3829 0.532227C15.5728 0.532227 15.7268 0.686203 15.7268 0.876132Z",
    fill: "url(#paint10_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6566 0.876132V1.59212C17.6566 1.78205 17.5026 1.93602 17.3126 1.93602C17.1227 1.93602 16.9688 1.78205 16.9688 1.59212V0.876132C16.9688 0.686203 17.1227 0.532227 17.3126 0.532227C17.5026 0.532227 17.6566 0.686203 17.6566 0.876132V0.876132Z",
    fill: "url(#paint11_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5784 0.876132V1.59212C19.5784 1.78205 19.4244 1.93602 19.2345 1.93602C19.0446 1.93602 18.8906 1.78205 18.8906 1.59212V0.876132C18.8906 0.686203 19.0446 0.532227 19.2345 0.532227C19.4244 0.532227 19.5784 0.686203 19.5784 0.876132V0.876132Z",
    fill: "url(#paint12_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5081 0.876132V2.2766C21.5081 2.46653 21.3541 2.62045 21.1642 2.62045C20.9743 2.62045 20.8203 2.46647 20.8203 2.2766V0.876132C20.8203 0.686203 20.9743 0.532227 21.1642 0.532227C21.3541 0.532227 21.5081 0.686203 21.5081 0.876132Z",
    fill: "url(#paint13_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4378 0.876132V1.59212C23.4378 1.78205 23.2838 1.93602 23.0939 1.93602C22.904 1.93602 22.75 1.78205 22.75 1.59212V0.876132C22.75 0.686203 22.904 0.532227 23.0939 0.532227C23.2839 0.532227 23.4378 0.686203 23.4378 0.876132V0.876132Z",
    fill: "url(#paint14_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3596 0.876132V1.59212C25.3596 1.78205 25.2056 1.93602 25.0157 1.93602C24.8258 1.93602 24.6719 1.78205 24.6719 1.59212V0.876132C24.6719 0.686203 24.8258 0.532227 25.0157 0.532227C25.2056 0.532227 25.3596 0.686203 25.3596 0.876132V0.876132Z",
    fill: "url(#paint15_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2816 0.876132V2.2766C27.2816 2.46653 27.1276 2.62045 26.9377 2.62045C26.7477 2.62045 26.5938 2.46647 26.5938 2.2766V0.876132C26.5938 0.686203 26.7477 0.532227 26.9377 0.532227C27.1276 0.532227 27.2816 0.686203 27.2816 0.876132Z",
    fill: "url(#paint16_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1193 4.43781H29.7188C29.5289 4.43781 29.375 4.28383 29.375 4.0939C29.375 3.90398 29.529 3.75 29.7188 3.75H31.1193C31.3092 3.75 31.4631 3.90398 31.4631 4.0939C31.4631 4.2839 31.3092 4.43781 31.1193 4.43781Z",
    fill: "url(#paint17_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1223 6.36457H30.4063C30.2164 6.36457 30.0625 6.21059 30.0625 6.02066C30.0625 5.83073 30.2165 5.67676 30.4063 5.67676H31.1223C31.3122 5.67676 31.4662 5.83073 31.4662 6.02066C31.4662 6.21059 31.3122 6.36457 31.1223 6.36457Z",
    fill: "url(#paint18_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1223 8.29126H30.4063C30.2164 8.29126 30.0625 8.13728 30.0625 7.94736C30.0625 7.75743 30.2165 7.60352 30.4063 7.60352H31.1223C31.3122 7.60352 31.4662 7.75749 31.4662 7.94736C31.4662 8.13728 31.3122 8.29126 31.1223 8.29126Z",
    fill: "url(#paint19_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1193 10.2181H29.7188C29.5289 10.2181 29.375 10.0641 29.375 9.87418C29.375 9.68425 29.529 9.53027 29.7188 9.53027H31.1193C31.3092 9.53027 31.4631 9.68425 31.4631 9.87418C31.4631 10.0642 31.3092 10.2181 31.1193 10.2181Z",
    fill: "url(#paint20_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1223 12.1448H30.4063C30.2164 12.1448 30.0625 11.9908 30.0625 11.8009C30.0625 11.611 30.2165 11.457 30.4063 11.457H31.1223C31.3122 11.457 31.4662 11.611 31.4662 11.8009C31.4662 11.9908 31.3122 12.1448 31.1223 12.1448Z",
    fill: "url(#paint21_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1223 14.0716H30.4063C30.2164 14.0716 30.0625 13.9176 30.0625 13.7277C30.0625 13.5378 30.2165 13.3838 30.4063 13.3838H31.1223C31.3122 13.3838 31.4662 13.5378 31.4662 13.7277C31.4662 13.9176 31.3122 14.0716 31.1223 14.0716Z",
    fill: "url(#paint22_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1193 15.9984H29.7188C29.5289 15.9984 29.375 15.8444 29.375 15.6545C29.375 15.4645 29.529 15.3105 29.7188 15.3105H31.1193C31.3092 15.3105 31.4631 15.4645 31.4631 15.6545C31.4631 15.8444 31.3092 15.9984 31.1193 15.9984Z",
    fill: "url(#paint23_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1223 17.925H30.4063C30.2164 17.925 30.0625 17.7711 30.0625 17.5811C30.0625 17.3912 30.2165 17.2373 30.4063 17.2373H31.1223C31.3122 17.2373 31.4662 17.3913 31.4662 17.5811C31.4662 17.7711 31.3122 17.925 31.1223 17.925Z",
    fill: "url(#paint24_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1223 19.8519H30.4063C30.2164 19.8519 30.0625 19.6979 30.0625 19.508C30.0625 19.318 30.2165 19.1641 30.4063 19.1641H31.1223C31.3122 19.1641 31.4662 19.318 31.4662 19.508C31.4662 19.698 31.3122 19.8519 31.1223 19.8519Z",
    fill: "url(#paint25_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1193 21.7786H29.7188C29.5289 21.7786 29.375 21.6246 29.375 21.4347C29.375 21.2448 29.529 21.0908 29.7188 21.0908H31.1193C31.3092 21.0908 31.4631 21.2448 31.4631 21.4347C31.4631 21.6246 31.3092 21.7786 31.1193 21.7786Z",
    fill: "url(#paint26_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1223 23.7054H30.4063C30.2164 23.7054 30.0625 23.5514 30.0625 23.3615C30.0625 23.1716 30.2165 23.0176 30.4063 23.0176H31.1223C31.3122 23.0176 31.4662 23.1716 31.4662 23.3615C31.4662 23.5514 31.3122 23.7054 31.1223 23.7054Z",
    fill: "url(#paint27_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1223 25.6321H30.4063C30.2164 25.6321 30.0625 25.4781 30.0625 25.2882C30.0625 25.0983 30.2165 24.9443 30.4063 24.9443H31.1223C31.3122 24.9443 31.4662 25.0983 31.4662 25.2882C31.4662 25.4782 31.3122 25.6321 31.1223 25.6321Z",
    fill: "url(#paint28_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1193 27.5588H29.7188C29.5289 27.5588 29.375 27.4049 29.375 27.2149C29.375 27.025 29.529 26.8711 29.7188 26.8711H31.1193C31.3092 26.8711 31.4631 27.0251 31.4631 27.2149C31.4631 27.4049 31.3092 27.5588 31.1193 27.5588Z",
    fill: "url(#paint29_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4107 31.4545H25.4695C25.0364 31.4545 24.6852 31.1033 24.6852 30.6702C24.6852 30.237 25.0364 29.8859 25.4695 29.8859H26.4107C26.8438 29.8859 27.195 30.237 27.195 30.6702C27.195 31.1033 26.8439 31.4545 26.4107 31.4545ZM22.3323 31.4545H21.3911C20.958 31.4545 20.6068 31.1033 20.6068 30.6702C20.6068 30.237 20.958 29.8859 21.3911 29.8859H22.3323C22.7654 29.8859 23.1166 30.237 23.1166 30.6702C23.1166 31.1033 22.7655 31.4545 22.3323 31.4545ZM18.2539 31.4545H17.3127C16.8795 31.4545 16.5284 31.1033 16.5284 30.6702C16.5284 30.237 16.8795 29.8859 17.3127 29.8859H18.2539C18.687 29.8859 19.0382 30.237 19.0382 30.6702C19.0382 31.1033 18.687 31.4545 18.2539 31.4545ZM14.1754 31.4545H13.2342C12.8011 31.4545 12.4499 31.1033 12.4499 30.6702C12.4499 30.237 12.8011 29.8859 13.2342 29.8859H14.1754C14.6086 29.8859 14.9597 30.237 14.9597 30.6702C14.9597 31.1033 14.6086 31.4545 14.1754 31.4545ZM10.097 31.4545H9.15582C8.72269 31.4545 8.3715 31.1033 8.3715 30.6702C8.3715 30.237 8.72269 29.8859 9.15582 29.8859H10.097C10.5301 29.8859 10.8813 30.237 10.8813 30.6702C10.8813 31.1033 10.5302 31.4545 10.097 31.4545ZM6.01856 31.4545H5.07739C4.64426 31.4545 4.29307 31.1033 4.29307 30.6702C4.29307 30.237 4.64426 29.8859 5.07739 29.8859H6.01856C6.45169 29.8859 6.80288 30.237 6.80288 30.6702C6.80288 31.1033 6.45175 31.4545 6.01856 31.4545ZM1.94013 31.4545H1.33119C0.898059 31.4545 0.546875 31.1033 0.546875 30.6702V30.3379C0.546875 29.9048 0.898059 29.5536 1.33119 29.5536C1.59635 29.5536 1.8307 29.6851 1.97269 29.8865C2.39077 29.9036 2.72444 30.248 2.72444 30.6702C2.72444 31.1034 2.37332 31.4545 1.94013 31.4545V31.4545ZM1.33125 27.985C0.898122 27.985 0.546938 27.6338 0.546938 27.2007V26.2595C0.546938 25.8264 0.898122 25.4752 1.33125 25.4752C1.76438 25.4752 2.11557 25.8264 2.11557 26.2595V27.2007C2.11557 27.6338 1.76438 27.985 1.33125 27.985ZM1.33125 23.9066C0.898122 23.9066 0.546938 23.5554 0.546938 23.1222V22.1811C0.546938 21.7479 0.898122 21.3967 1.33125 21.3967C1.76438 21.3967 2.11557 21.7479 2.11557 22.1811V23.1222C2.11557 23.5554 1.76438 23.9066 1.33125 23.9066ZM1.33125 19.8281C0.898122 19.8281 0.546938 19.4769 0.546938 19.0438V18.1026C0.546938 17.6695 0.898122 17.3183 1.33125 17.3183C1.76438 17.3183 2.11557 17.6695 2.11557 18.1026V19.0438C2.11557 19.4769 1.76438 19.8281 1.33125 19.8281ZM1.33125 15.7497C0.898122 15.7497 0.546938 15.3985 0.546938 14.9654V14.0242C0.546938 13.5911 0.898122 13.2399 1.33125 13.2399C1.76438 13.2399 2.11557 13.5911 2.11557 14.0242V14.9654C2.11557 15.3985 1.76438 15.7497 1.33125 15.7497ZM1.33125 11.6712C0.898122 11.6712 0.546938 11.3201 0.546938 10.8869V9.94576C0.546938 9.51263 0.898122 9.16144 1.33125 9.16144C1.76438 9.16144 2.11557 9.51263 2.11557 9.94576V10.8869C2.11557 11.3201 1.76438 11.6712 1.33125 11.6712ZM1.33125 7.59281C0.898122 7.59281 0.546938 7.24163 0.546938 6.8085V5.86732C0.546938 5.43419 0.898122 5.08301 1.33125 5.08301C1.76438 5.08301 2.11557 5.43419 2.11557 5.86732V6.8085C2.11557 7.24163 1.76438 7.59281 1.33125 7.59281Z",
    fill: "#7B7B8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.6682 32.0005C2.58953 32.0005 3.33641 31.2536 3.33641 30.3323C3.33641 29.4109 2.58953 28.6641 1.6682 28.6641C0.74688 28.6641 0 29.4109 0 30.3323C0 31.2536 0.74688 32.0005 1.6682 32.0005Z",
    fill: "url(#paint30_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.6735 31.7239C2.44242 31.7239 3.06575 31.1006 3.06575 30.3317C3.06575 29.5628 2.44242 28.9395 1.6735 28.9395C0.904582 28.9395 0.28125 29.5628 0.28125 30.3317C0.28125 31.1006 0.904582 31.7239 1.6735 31.7239Z",
    fill: "url(#paint31_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41037 28.8398C2.52287 29.0644 2.58631 29.3178 2.58631 29.5861C2.58631 30.5074 1.83939 31.2543 0.918102 31.2543C0.649804 31.2543 0.39644 31.1908 0.171875 31.0783C0.445695 31.625 1.01103 32.0004 1.66408 32.0004C2.58543 32.0004 3.33228 31.2535 3.33228 30.3322C3.33235 29.6791 2.957 29.1138 2.41037 28.8398V28.8398Z",
    fill: "url(#paint32_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.6682 8.0327C2.58953 8.0327 3.33641 7.28582 3.33641 6.3645C3.33641 5.44317 2.58953 4.69629 1.6682 4.69629C0.74688 4.69629 0 5.44317 0 6.3645C0 7.28582 0.74688 8.0327 1.6682 8.0327Z",
    fill: "url(#paint33_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.6735 7.75716C2.44242 7.75716 3.06575 7.13383 3.06575 6.36491C3.06575 5.59599 2.44242 4.97266 1.6735 4.97266C0.904582 4.97266 0.28125 5.59599 0.28125 6.36491C0.28125 7.13383 0.904582 7.75716 1.6735 7.75716Z",
    fill: "url(#paint34_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41037 4.87207C2.52287 5.09664 2.58631 5.35006 2.58631 5.6183C2.58631 6.53965 1.83939 7.2865 0.918102 7.2865C0.649804 7.2865 0.39644 7.22307 0.171875 7.11056C0.445757 7.6572 1.01109 8.03254 1.66414 8.03254C2.58549 8.03254 3.33235 7.28562 3.33235 6.36434C3.33235 5.71135 2.957 5.14602 2.41037 4.87207V4.87207Z",
    fill: "url(#paint35_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6526 32.0005C26.5739 32.0005 27.3208 31.2536 27.3208 30.3323C27.3208 29.4109 26.5739 28.6641 25.6526 28.6641C24.7313 28.6641 23.9844 29.4109 23.9844 30.3323C23.9844 31.2536 24.7313 32.0005 25.6526 32.0005Z",
    fill: "url(#paint36_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6579 31.7239C26.4268 31.7239 27.0501 31.1006 27.0501 30.3317C27.0501 29.5628 26.4268 28.9395 25.6579 28.9395C24.889 28.9395 24.2656 29.5628 24.2656 30.3317C24.2656 31.1006 24.889 31.7239 25.6579 31.7239Z",
    fill: "url(#paint37_linear_152_690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3947 28.8398C26.5072 29.0644 26.5707 29.3178 26.5707 29.5861C26.5707 30.5074 25.8238 31.2543 24.9025 31.2543C24.6342 31.2543 24.3808 31.1908 24.1562 31.0783C24.4301 31.625 24.9955 32.0003 25.6485 32.0003C26.5699 32.0003 27.3167 31.2534 27.3167 30.3321C27.3167 29.6791 26.9414 29.1138 26.3947 28.8398V28.8398Z",
    fill: "url(#paint38_linear_152_690)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_152_690",
    x1: 14.856,
    y1: -6.86978,
    x2: 28.3994,
    y2: 57.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_152_690",
    x1: 20.9659,
    y1: 10.9354,
    x2: 14.8095,
    y2: -6.84974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_152_690",
    x1: 16.3471,
    y1: -0.101082,
    x2: 16.3471,
    y2: 9.71884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_152_690",
    x1: 32.119,
    y1: 15.6547,
    x2: 26.5098,
    y2: 15.6547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_152_690",
    x1: 3.7404,
    y1: 1.57637,
    x2: 4.44798,
    y2: 1.57637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_152_690",
    x1: 5.67009,
    y1: 1.23416,
    x2: 6.37773,
    y2: 1.23416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_152_690",
    x1: 7.59203,
    y1: 1.23416,
    x2: 8.2996,
    y2: 1.23416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_152_690",
    x1: 9.52159,
    y1: 1.57637,
    x2: 10.2292,
    y2: 1.57637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_152_690",
    x1: 11.4514,
    y1: 1.23416,
    x2: 12.159,
    y2: 1.23416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_152_690",
    x1: 13.3732,
    y1: 1.23416,
    x2: 14.0808,
    y2: 1.23416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_152_690",
    x1: 15.3028,
    y1: 1.57637,
    x2: 16.0104,
    y2: 1.57637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_152_690",
    x1: 17.2327,
    y1: 1.23416,
    x2: 17.9402,
    y2: 1.23416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_152_690",
    x1: 19.1544,
    y1: 1.23416,
    x2: 19.862,
    y2: 1.23416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_152_690",
    x1: 21.0842,
    y1: 1.57637,
    x2: 21.7918,
    y2: 1.57637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_152_690",
    x1: 23.0139,
    y1: 1.23416,
    x2: 23.7215,
    y2: 1.23416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_152_690",
    x1: 24.9357,
    y1: 1.23416,
    x2: 25.6432,
    y2: 1.23416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_152_690",
    x1: 26.8577,
    y1: 1.57637,
    x2: 27.5652,
    y2: 1.57637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_152_690",
    x1: 30.4191,
    y1: 4.0139,
    x2: 30.4191,
    y2: 4.72148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_152_690",
    x1: 30.7643,
    y1: 5.9406,
    x2: 30.7643,
    y2: 6.64824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_152_690",
    x1: 30.7643,
    y1: 7.86736,
    x2: 30.7643,
    y2: 8.57493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_152_690",
    x1: 30.4191,
    y1: 9.79418,
    x2: 30.4191,
    y2: 10.5018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_152_690",
    x1: 30.7643,
    y1: 11.7208,
    x2: 30.7643,
    y2: 12.4284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_152_690",
    x1: 30.7643,
    y1: 13.6477,
    x2: 30.7643,
    y2: 14.3553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_152_690",
    x1: 30.4191,
    y1: 15.5744,
    x2: 30.4191,
    y2: 16.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_152_690",
    x1: 30.7643,
    y1: 17.5011,
    x2: 30.7643,
    y2: 18.2087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_152_690",
    x1: 30.7643,
    y1: 19.428,
    x2: 30.7643,
    y2: 20.1355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_152_690",
    x1: 30.4191,
    y1: 21.3546,
    x2: 30.4191,
    y2: 22.0622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_152_690",
    x1: 30.7643,
    y1: 23.2814,
    x2: 30.7643,
    y2: 23.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_152_690",
    x1: 30.7643,
    y1: 25.2082,
    x2: 30.7643,
    y2: 25.9157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_152_690",
    x1: 30.4191,
    y1: 27.1349,
    x2: 30.4191,
    y2: 27.8424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_152_690",
    x1: 1.04408,
    y1: 29.7081,
    x2: 3.20471,
    y2: 31.8687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_152_690",
    x1: 1.87366,
    y1: 30.6154,
    x2: 0.844391,
    y2: 29.1562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_152_690",
    x1: 1.72206,
    y1: 30.9715,
    x2: 4.01507,
    y2: 26.7068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_152_690",
    x1: 1.04408,
    y1: 5.74031,
    x2: 3.20471,
    y2: 7.90093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_152_690",
    x1: 1.87366,
    y1: 6.64864,
    x2: 0.844388,
    y2: 5.18938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_152_690",
    x1: 1.72206,
    y1: 7.00371,
    x2: 4.01508,
    y2: 2.73899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_152_690",
    x1: 25.0284,
    y1: 29.7081,
    x2: 27.189,
    y2: 31.8687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_152_690",
    x1: 25.858,
    y1: 30.6154,
    x2: 24.8288,
    y2: 29.1562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_152_690",
    x1: 25.7065,
    y1: 30.9715,
    x2: 27.9995,
    y2: 26.7068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_152_690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgT2);
export default __webpack_public_path__ + "static/media/t2.dcfc649b1b88ca3d66aec28cc42620a7.svg";
export { ForwardRef as ReactComponent };